import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AppService } from './../appservice.service';
import { Router, ActivatedRoute } from '@angular/router';
import { first } from 'rxjs/operators';

import { FormControl, FormGroup } from '@angular/forms';
import { AuthenticationService } from '../_services/authentication.service';
import { ElectronService } from 'ngx-electron';
import { ChangepassowrdComponent } from '../settings/changepassowrd/changepassowrd.component';
import { MatDialog } from '@angular/material';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  licmsg = '';
  loading = false;
  submitted = false;
  returnUrl: string;
  error = '';
  loginForm = new FormGroup({
    username: new FormControl(),
    password: new FormControl(),
    rememberme: new FormControl(false)
  });
  year = (new Date()).getFullYear();

  constructor(public translate: TranslateService, public service: AppService,
    private route: ActivatedRoute, private router: Router,
    public authenticationService: AuthenticationService, public eservice: ElectronService,
    public dialog: MatDialog) {
    translate.setDefaultLang('en');
  }

  ngOnInit() {

    if (!this.service.isactive) {
      this.router.navigate(['/activate']);
    }

    // reset login status
    this.authenticationService.logout();

    // get return url from route parameters or default to '/'
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/home';
    console.log('locka item '+ this.service.getlocalitem('rememberme'));
    if (this.service.getlocalitem('rememberme') && this.service.getlocalitem('un')) {
      let uname = String(this.service.getlocalitem('un')).split('|');
      if (!this.eservice.isElectronApp) {
        uname = String(this.service.decrypt(this.service.getlocalitem('un'))).split('|');
      }
      this.loginForm.patchValue({ rememberme: this.service.getlocalitem('rememberme'), username: uname[0], password: uname[1] });
      this.onSubmit();
    }
  }

  // convenience getter for easy access to form fields
  get f() { return this.loginForm.controls; }

  onSubmit() {

    try {
      // this.service.login(this.myGroup.value.username, this.myGroup.value.password, this.myGroup.value.remember);
      this.submitted = true;

      // stop here if form is invalid
      if (this.loginForm.invalid) {
        return;
      }
      console.log(' chk ' + this.loginForm.value.rememberme);
      this.loading = true;
      this.authenticationService.login(this.f.username.value, this.f.password.value, this.f.rememberme.value)
        .subscribe(
          restItems => {
            console.log(restItems);
            this.loading = false;
            if (restItems.success) {
              // this.isReady = true;
              // this.isactive = true;
              this.service.isloaded = true;
              // this.appservice.retryReady();
              // login successful if there's a jwt token in the response
              if (restItems && restItems.token) {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('currentUser', JSON.stringify(restItems));
                console.log(this.f.rememberme.value);
                if (this.f.rememberme.value) {
                  this.service.setlocalitem('rememberme', this.f.rememberme.value);
                  if (!this.eservice.isElectronApp) {
                    this.service.setlocalitem('un', this.service.encrypt(this.f.username.value + '|' + this.f.password.value));
                  } else {
                    this.service.setlocalitem('un', this.f.username.value + '|' + this.f.password.value);
                  }
                }
                this.service.islogin = true;
                console.log(restItems);
                this.service.isadmin = restItems.admin;
                console.log('data admin :' + this.service.isadmin);
                if (this.service.isadmin) {
                  if (this.service.getlocalitem('default_page') != null && this.service.getlocalitem('default_page') === '2') {
                    this.returnUrl = '/invoice/0';
                  }
                } else {
                  this.returnUrl = '/invoice/0';
                }
                setTimeout(() => {
                  this.service.backup();
                }, 15000);
                this.router.navigate([this.returnUrl]);
                return restItems;
              } else {
                this.service.sendMessage(restItems.message);
                return restItems;
              }
            } else {
              this.service.sendMessage(restItems.message);
              return restItems;
            }
          },
          error => {
            this.loading = false;
            console.log('login error :' + error);
            this.service.sendMessage('Login.LoginFailedError');
            return { 'success': false, 'message': 'error' };
          }
        );
    } catch (e) {
      console.log(e);
      this.service.sendMessage('Oops');
    }
    // .(
    //   data => {
    //     this.router.navigate([this.returnUrl]);
    //   },
    //   error => {
    //     this.error = error;
    //     this.loading = false;
    //   });
  }


  openChangePassDialog(): boolean {
    const dialogRef = this.dialog.open(ChangepassowrdComponent, {
      width: '600px',
      data: {
        name: ''
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // console.log(result);

      }
    });

    return false;
  }
}
